module.exports = __webpack_public_path__ + "media/src/application/media/svg/status-list-1e82218df7873d597cc71dfa7af68af0.svg";